import SDKError, { ERROR_CODE } from "../constants/error";
import { ECPair, network, toXOnly, tweakSigner } from "../bitcoin";
import { payments } from "bitcoinjs-lib";
function isPrivateKey(privateKey) {
    let isValid = false;
    try {
        // init key pair from senderPrivateKey
        const keyPair = ECPair.fromPrivateKey(privateKey);
        // Tweak the original keypair
        const tweakedSigner = tweakSigner(keyPair, { network });
        // Generate an address from the tweaked public key
        const p2pktr = payments.p2tr({
            pubkey: toXOnly(tweakedSigner.publicKey),
            network
        });
        const senderAddress = p2pktr.address ? p2pktr.address : "";
        isValid = senderAddress !== "";
    }
    catch (e) {
        isValid = false;
    }
    return isValid;
}
class Validator {
    constructor(label, value) {
        if (!label && typeof label !== "string") {
            throw new SDKError(ERROR_CODE.INVALID_VALIDATOR_LABEL);
        }
        this.value = value;
        this.label = label;
        this.isRequired = false;
    }
    _throwError(message) {
        throw new Error(`Validating "${this.label}" failed: ${message}. Found ${this.value} (type of ${typeof this.value})`);
    }
    _isDefined() {
        return this.value !== null && this.value !== undefined;
    }
    _onCondition(condition, message) {
        if (((!this.isRequired && this._isDefined()) || this.isRequired) &&
            !condition()) {
            this._throwError(message);
        }
        return this;
    }
    required(message = "Required") {
        this.isRequired = true;
        return this._onCondition(() => this._isDefined(), message);
    }
    string(message = "Must be string") {
        return this._onCondition(() => typeof this.value === "string", message);
    }
    buffer(message = "Must be buffer") {
        return this._onCondition(() => Buffer.isBuffer(this.value), message);
    }
    function(message = "Must be a function") {
        return this._onCondition(() => typeof this.value === "function", message);
    }
    boolean(message = "Must be boolean") {
        return this._onCondition(() => typeof this.value === "boolean", message);
    }
    number(message = "Must be number") {
        return this._onCondition(() => Number.isFinite(this.value), message);
    }
    array(message = "Must be array") {
        return this._onCondition(() => this.value instanceof Array, message);
    }
    privateKey(message = "Invalid private key") {
        return this._onCondition(() => this.buffer() && isPrivateKey(this.value), message);
    }
}
export default Validator;
//# sourceMappingURL=validator.js.map